import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fae2e80&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowRight: require('/usr/src/app/components/icons/arrow-right.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,LnForm: require('/usr/src/app/components/ln-form/ln-form.vue').default,TwoItemsCta: require('/usr/src/app/components/common-sections/two-items-cta.vue').default,BaseWhyChooseLegalnatureVideo: require('/usr/src/app/components/base-why-choose-legalnature/components/base-why-choose-legalnature-video.vue').default})
